import { isLocalHost } from '../helpers/environmentHelper';

export enum CHAT_AGENT_HOST {
  PRD = 'prdelorachatstg',
  SBX = 'sbxelorachatstg',
}

// Where the Elora Chat widget is served from (an Azure storage static site).
export const getChatAgentHostUrl = () =>
  `https://${isLocalHost() ? CHAT_AGENT_HOST.SBX : CHAT_AGENT_HOST.PRD}.z28.web.core.windows.net`;
